import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CButtonGroup,
  CCol,
  CFormInput,
  CFormSelect,
  CFormSwitch,
  CRow,
} from '@coreui/react'
import './template.scss'
import { AppContext } from 'src/views/context/app'
import EditIcon from '../../assets/edit-icon.svg'
import { formatBytes, getThumbnail } from 'src/views/utils/helper'
import { GlobalContext } from 'src/views/context/GlobalState'
import ImageNotFound from '../../assets/image-not-found.jpg'

const AttachLink = ({
  title = 'Assign a link',
  categoryData = [],
  linkData,
  setLinkData,
  id = '',
  astrick = false,
  selectorWidth = '68%',
  disabled = false,
}) => {
  const { userSessionObj } = useContext(GlobalContext)
  const {
    setContentModalProps,
    setArtistModalProps,
    setVenueModalProps,
    setPageModalProps,
    setIptvModalProps,
    accountObj,
  } = useContext(AppContext)
  const [selectedEntity, setSelectedEntity] = useState('')
  const [selectedCategory, setSelectedCategory] = useState('')
  const [popUpToggle, setPopUpToggle] = useState(false)

  useEffect(() => {
    if (linkData?.type !== 'EXTERNAL') {
      setSelectedEntity(linkData?.type)
    }
    if (linkData?.type === 'EXTERNAL') {
      setPopUpToggle(linkData?.data?.popup_enabled ? true : false)
    }
    if (linkData?.type === 'CATEGORY' && linkData?.data?.id) {
      setSelectedCategory(linkData?.data?.id)
    }
  }, [linkData])

  const onLinkTypeChange = (event) => {
    const { value } = event.target
    setSelectedEntity('')
    setSelectedCategory('')
    setPopUpToggle(false)
    if (value === 'EXTERNAL') {
      setLinkData({ type: 'EXTERNAL', data: { url: '', popup_enabled: false } })
      return
    }
    setLinkData({ type: '', data: {} })
  }

  const onSelectOptionChange = (value) => {
    setSelectedEntity(value)
    if (
      value === 'CONTENT_DETAIL' ||
      value === 'ARTIST_DETAIL' ||
      value === 'VENUE_DETAIL' ||
      value === 'PAGES' ||
      value === 'IPTV'
    ) {
      openModal(value)
    }

    setLinkData({ type: value, data: {} })
  }

  const openModal = (type, id = '') => {
    if (type === 'CONTENT_DETAIL') {
      setContentModalProps({
        type: 'single',
        mappedContentId: id,
        mappedContentArray: [],
        selectCallback: (contentId, contents) => {
          setLinkData({
            type: type,
            data: {
              id: contentId,
              title: contents[0]?.title,
              description: contents[0]?.description,
              thumbnail: contents[0]?.thumbnail?.website?.s3_key,
              other: [
                { name: 'Type', value: contents[0]?.video_type || '--' },
                { name: 'Category', value: contents[0]?.category?.name },
                {
                  name: 'Size',
                  value: contents[0]?.source_asset
                    ? ['LIVE', 'MPVP'].includes(contents[0]?.video_type)
                      ? '-'
                      : formatBytes(contents[0]?.source_asset?.file_metadata?.file_size)
                    : '--',
                },
              ],
            },
          })
        },
      })
    }

    if (type === 'ARTIST_DETAIL') {
      setArtistModalProps({
        mappedArtistId: id,
        type: 'single',
        selectCallback: (artistObj) => {
          setLinkData({
            type: type,
            data: {
              id: artistObj._id,
              title: artistObj?.name,
              description: artistObj?.bio,
              thumbnail: artistObj?.poster?.s3_key,
              other: [
                {
                  name: 'Type',
                  value: artistObj?.artist_type,
                },
              ],
            },
          })
        },
      })
    }
    if (type === 'VENUE_DETAIL') {
      setVenueModalProps({
        mappedVenuetId: id,
        type: 'single',
        selectCallback: (venueObj) => {
          setLinkData({
            type: type,
            data: {
              id: venueObj._id,
              title: venueObj?.name,
              description: venueObj?.description,
              thumbnail: venueObj?.thumbnail?.s3_key,
              other: [
                {
                  name: 'Address',
                  value: venueObj?.address,
                },
              ],
            },
          })
        },
      })
    }
    if (type === 'PAGES') {
      setPageModalProps({
        mappedPageId: id,
        type: 'single',
        selectCallback: (pageObj) => {
          setLinkData({
            type: type,
            data: {
              id: pageObj._id,
              title: `Page Name : ${pageObj?.name}`,
              description:
                pageObj?.type === 'STATIC'
                  ? `Page URL : ${accountObj?.domain_name}/static${pageObj?.page_url}`
                  : `Page URL : ${accountObj?.domain_name}/custom${pageObj?.page_url}`,
              thumbnail: '',
              page_url:
                pageObj?.type === 'STATIC'
                  ? `/static${pageObj?.page_url}`
                  : `/custom${pageObj?.page_url}`,
              other: [],
            },
          })
        },
      })
    }
    if (type === 'IPTV') {
      setIptvModalProps({
        mappedChannelId: id,
        selectCallback: (channelObj) => {
          setLinkData({
            type: type,
            data: {
              id: channelObj._id,
              title: channelObj?.name,
              description: channelObj?.description,
              thumbnail: channelObj?.thumbnail?.website?.s3_key,
              other: [],
            },
          })
        },
      })
    }
  }

  const onCategoryChange = (value) => {
    setSelectedCategory(value)
    let catObj = categoryData.find((info) => info._id === value)
    setLinkData({
      type: 'CATEGORY',
      data: {
        id: value,
        name: catObj ? catObj?.name : '',
      },
    })
  }

  const onPopupToggle = (e) => {
    setLinkData({
      type: 'EXTERNAL',
      data: { ...linkData.data, popup_enabled: !popUpToggle },
    })
    setPopUpToggle((prev) => !prev)
  }

  return (
    <>
      <CRow className="mt-1 mb-3">
        <div className="d-flex justify-content-between align-items-center ">
          {title && (
            <h6 style={{ fontSize: '13px' }}>
              {title} {astrick && <span style={{ color: 'red' }}>*</span>}
            </h6>
          )}
          <div
            style={{ width: title ? selectorWidth : '100%' }}
            className="d-flex align-items-center"
          >
            <CButtonGroup role="group">
              <CButton
                className={`${
                  linkData?.type !== 'EXTERNAL' ? 'btn-attach-link-active' : 'btn-attach-link'
                } btn-attach-link  btn-focus-none`}
                name={`entity${id}`}
                id={`entity${id}`}
                value={`ENTITY`}
                disabled={disabled}
                onClick={(e) => onLinkTypeChange(e)}
              >
                Select Entity
              </CButton>
              <CButton
                className={`${
                  linkData?.type === 'EXTERNAL' ? 'btn-attach-link-active' : 'btn-attach-link'
                } btn-focus-none`}
                name={`external${id}`}
                id={`external${id}`}
                value={`EXTERNAL`}
                checked={linkData?.type === 'EXTERNAL'}
                onClick={(e) => onLinkTypeChange(e)}
                disabled={disabled}
              >
                External Link
              </CButton>
            </CButtonGroup>
            <div className="ml-5" style={{ fontSize: '14px' }}>
              {linkData?.type === 'EXTERNAL' && (
                <CFormSwitch
                  label={`Pop-up ${popUpToggle ? 'Enabled' : 'Disabled'}`}
                  className="ml-2"
                  id="popUpToggleSwitch"
                  value={popUpToggle}
                  checked={popUpToggle}
                  valid={popUpToggle}
                  onChange={(e) => onPopupToggle(e)}
                />
              )}
            </div>
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol>
          {linkData?.type !== 'EXTERNAL' ? (
            <CFormSelect
              placeholder="Select Entity"
              value={selectedEntity}
              onChange={(e) => onSelectOptionChange(e.target.value)}
              style={{ fontSize: '13px' }}
              disabled={disabled}
            >
              <option value="" selected disabled>
                Select Entity
              </option>
              <option value={'ARTIST_DETAIL'}>Artist Detail page</option>
              <option value={'ARTIST_LIST'}>Artist listing page</option>
              <option value={'CATEGORY'}>Category landing page</option>
              <option value={'PAGES'}>Pages</option>
              <option value={'CONTENT_DETAIL'}>Content Detail Page</option>
              <option value={'LOGIN'}>Log-in page</option>
              <option value={'REGISTER'}>Register Page</option>
              <option value={'HOME'}>Home Page</option>
              <option value={'IPTV'}>IPTV Channel</option>
              <option value={'ALL_IPTV'}>All IPTV Channels</option>
              <option value={'PRICING'}>Pricing Page</option>
              <option value={'VENUE_DETAIL'}>Venue Detail page</option>
              <option value={'VENUE_LIST'}>Venue listing page</option>
            </CFormSelect>
          ) : (
            <CFormInput
              type="text"
              onChange={(e) => {
                setLinkData({
                  type: 'EXTERNAL',
                  data: { ...linkData.data, url: e.target.value },
                })
                // validURL(e.target.value)
              }}
              disabled={disabled}
              style={{ fontSize: '13px' }}
              value={linkData?.data?.url}
            />
          )}
        </CCol>
      </CRow>
      {linkData?.type !== 'EXTERNAL' && linkData?.data?.title && (
        <CRow className="mt-3">
          <CCol>
            <div className="attach-link-box flex position-relative">
              {linkData.data.thumbnail && (
                <img
                  src={getThumbnail(
                    userSessionObj.session_data.cf_domain_name,
                    linkData.data.thumbnail,
                  )}
                  alt="link img"
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null // prevents looping
                    currentTarget.src = ImageNotFound
                  }}
                />
              )}

              <div
                style={{ marginTop: '9px', width: '76%' }}
                className="ml-4 mr-5 flex flex-column justify-content-between"
              >
                <span style={{ fontSize: '17px', fontWeight: 500 }} className="line-clamp-1">
                  {linkData.data.title}
                </span>
                <span
                  style={{ fontSize: '11.5px', color: linkData?.type === 'PAGES' ? '#0073f6' : '' }}
                  className="mt-1 line-clamp-2"
                >
                  {linkData.data.description}
                </span>
                <span style={{ fontSize: '12px' }} className="mt-2 line-clamp-1">
                  {linkData.data.other.map((info, index) => {
                    return ` ${index ? `\u00a0\u00a0` : ''} ${info.name} : ${
                      info.value
                    } \u00a0\u00a0 ${index < linkData.data.other.length - 1 ? ' | ' : ''}`
                  })}
                </span>
              </div>
              <div className="position-absolute right-2">
                <div
                  className=" h-[25px] w-[25px] rounded-full bg-[#20211c] flex justify-center items-center cursor-pointer"
                  style={{
                    boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)',
                    border: 'solid 0.5px #fff',
                  }}
                  onClick={() => openModal(linkData.type, linkData.data.id)}
                >
                  <img
                    src={EditIcon}
                    style={{
                      width: '14px',
                      height: '14px',
                    }}
                    className=""
                    alt="editicon"
                  />
                </div>
              </div>
            </div>
          </CCol>
        </CRow>
      )}

      {linkData?.type === 'CATEGORY' && (
        <CFormSelect
          placeholder="Select Category"
          className="mt-3"
          value={selectedCategory}
          onChange={(e) => onCategoryChange(e.target.value)}
          style={{ fontSize: '13px' }}
          disabled={disabled}
        >
          <option value="" selected disabled>
            Choose Category
          </option>
          {categoryData.map((info) => (
            <option key={info._id} value={info._id}>
              {info.name}
            </option>
          ))}
        </CFormSelect>
      )}
    </>
  )
}

export default AttachLink
